import React, { useState } from 'react';
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface HoverButtonProps {
  id?: string;
  icon: IconName;
  onClick: () => void | Promise<void>;
  title: string;
  className?: string;
  text?: string;
  clickTimeout?: number;
  highlight?: boolean;
  loading?: boolean;
}

export const HoverButton: React.FC<HoverButtonProps> = ({
  id,
  icon,
  onClick,
  title,
  className = '',
  text,
  highlight,
  clickTimeout = 2500,
  loading = false,
}) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = async () => {
    if (loading) return; // Verhindere mehrfaches Klicken während Loading
    
    const result = onClick();
    
    // Wenn onClick ein Promise zurückgibt, warte darauf
    if (result instanceof Promise) {
      try {
        await result;
        setClicked(true);
        if (clickTimeout > 0) {
          setTimeout(() => {
            setClicked(false);
          }, clickTimeout);
        }
      } catch (error) {
        console.error('Error in onClick handler:', error);
      }
    } else {
      setClicked(true);
      if (clickTimeout > 0) {
        setTimeout(() => {
          setClicked(false);
        }, clickTimeout);
      }
    }
  };

  // Loading-State hat Priorität
  const stateText = loading 
    ? `${text}...` 
    : (clicked || highlight) 
      ? `${text} - OK!` 
      : text;
  const stateIcon = loading 
    ? 'spinner' as IconName 
    : (clicked || highlight) 
      ? 'check' as IconName 
      : icon;
  const stateClass = loading 
    ? 'hover-button-loading' 
    : (clicked || highlight) 
      ? 'hover-button-clicked' 
      : '';
  const iconClass = loading ? 'fa-spin' : '';

  return (
    <button
      id={id}
      className={`hover-button ${className} ${stateClass}`}
      title={title}
      aria-label={title}
      onClick={handleClick}
      disabled={loading}
    >
      <FontAwesomeIcon icon={stateIcon} className={iconClass} /> {stateText}
    </button>
  );
};